import { html, css } from 'lit-element';
import { LitEntity } from '../../utility/lit-entity';
import './bin-smoothing-enabled';

class BinLevelAmplitudeImage extends LitEntity {
  static get properties() {
    return {
      threeDImageSrc: { type: String, attribute: false },
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }
      img {
        display: block;
      }
    `;
  }

  render() {
    return html`
      <img src=${this.threeDImageSrc || ''}>
    `;
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    const threeDImagesId = this.entity.getSubEntityByRel('https://api.binsentry.com/rel/3d-images').href;
    const threeDImageEntity = await this.fetchSiren(threeDImagesId);

    const amplitudeImageHref = threeDImageEntity.getSubEntityByRel('https://api.binsentry.com/rel/amplitude-image')?.href;

    const response = await this.fetchRaw(amplitudeImageHref);
    this.threeDImageSrc = URL.createObjectURL(await new Response(response).blob());
  }
}

window.customElements.define('bin-level-amplitude-image', BinLevelAmplitudeImage);
